import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import TextComponent from '../../../Component/Render/Text';

export class ScoreTextPopIn extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);
        const textComponent = gameObject.getComponent(TextComponent);

        textComponent.alpha = 1;

        const tweenPosition = this.getTween(transform.position);
        const tweenAlpha = this.getTween(textComponent);

        tweenPosition
            .to({ y: (meta?.animateDown) ? transform.y + 100 : transform.y - 100 }, 600)
            .easing(Easing.Cubic.Out);

        yield* this.startTween(tweenPosition);

        tweenAlpha.to({ alpha: 0 }, 200);

        yield* this.startTween(tweenAlpha);

        gameObject.destroy();
    }
}
